jQuery( document ).ready( function ( $ ) {
	let activeSection;
	let allSections = $( '.solution-tabs' );
	let allTabs = $( '.tab-content' );

	function sliderInitialForSection( activeSection ) {
		const elem = activeSection;

			$( elem ).find( '.slider-for' ).not( '.slick-initialized' ).slick( {
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				asNavFor: $( elem ).find( '.slider-nav' ),
				adaptiveHeight: true
			} );

			$( elem ).find( '.slider-nav' ).not( '.slick-initialized' ).slick( {
				slidesToShow: 1,
				slidesToScroll: 1,
				asNavFor: $( elem ).find( '.slider-for' ),
				dots: true,
				focusOnSelect: true,
				prevArrow: '<button type="button" class="prev-button"></button>',
				nextArrow: '<button type="button" class="next-button"></button>',
			} );
	}

	tabListClick();

	if ( window.innerWidth <= 1024 ) {
		allSections.each( function ( i ) {
			sliderInitialForSection( this );
		} )
	}

	allTabs.each( function () {
		let currentTab = $(this);
		if (window.innerWidth > 1024 && $(this).hasClass('slide-content')) {
			$(currentTab).each( function () {
				initStickyTabContent(this);
			})

		}
	} )


	function initStickyTabContent(context) {
		let currentTab = $(context);
		let columns = currentTab.find('.half-block');

		let FIRST_COLUMN_HEIGHT = $(columns.get(0)).height();
		let SECOND_COLUMN_HEIGHT = $(columns.get(1)).height();
		let INDEX = FIRST_COLUMN_HEIGHT >= SECOND_COLUMN_HEIGHT ? 1 : 0;
		$(columns.get(INDEX)).addClass('fixed');
	}

	function tabListClick() {
		$( document ).on( 'click', '.tab-list', function ( e ) {
			if ( !$( '.slider-for' ).hasClass( 'slick-initialized' ) ) {
				const current = e.target;
				let parentSection = $( this ).parents( '.solution-tabs' );

				if ( current.classList.contains( 'active' ) ) {
					return true;
				} else {
					parentSection.find( 'li' ).removeClass( 'active' );
					current.classList.add( 'active' );
					let tab_id = current.getAttribute( 'data-tab' );
					parentSection.find( '.tab-content' ).removeClass( 'current' );
					parentSection.find( '.' + tab_id ).addClass( 'current' );

					let elem = parentSection[0].querySelector('.tab-content.current');
					if (elem.classList.contains('slide-content')) {
						initStickyTabContent(elem);
					}	
						$( elem )[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
						elem.style.paddingTop = '180px';
				}
			}
		} );
	}

	$( document ).on( 'wheel', function () {
		if ($('.tab-content.current')) {
			setTimeout(()=>{
				$('.tab-content.current').css({'padding-top': '0'});
			}, 200)

		}
	} )

	window.addEventListener( 'resize', function ( event ) {
		if ( window.innerWidth <= 1024 ) {
			allSections.each( function ( i ) {
				sliderInitialForSection( this );
			} )
		} else {
			if ( $( '.slider-for' ).hasClass( 'slick-initialized' ) ) {
				$( '.slider-for' ).slick( 'unslick' );
				$( '.slider-nav' ).slick( 'unslick' );
			}
		}
	} );

} )